import { render, staticRenderFns } from "./zh.vue?vue&type=template&id=53fbfa02&scoped=true&"
import script from "./zh.vue?vue&type=script&lang=js&"
export * from "./zh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fbfa02",
  null
  
)

export default component.exports